module.exports = __webpack_public_path__ + "static/confetti-right-7f0aefc71d7bc2d7aaaba8c32f309128.png";